var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['svg-wrapper', { loading: _vm.loading }],domProps:{"innerHTML":_vm._s(_vm.innerMarkup)}})
}
var staticRenderFns = []

export { render, staticRenderFns }